<template>
  <div>
    <div :class="['case-napomene', 'case-aktivnost', 'section']">
      <!-- notes.length == 0 ? 'napomene-prazne' : '', -->
      <div class="section-title napomene-title">{{ $t('components.qna_table.client_inquiries') }}</div>

      <div class="case-napomene-wrapper" v-if="qa_table.length > 0">
        <div
          class="case-napomena"
          v-for="(single_qa, key) in qa_table"
          :key="key"
        >
          <div class="case-napomena-datum">
            <div>
              {{ switchDate(single_qa.question_ts) }}<br />{{
                getTime(single_qa.question_ts)
              }}
            </div>
            <div class="event-green" v-if="single_qa.answear">{{ $t('components.qna_table.answered') }}</div>
            <div class="case-napomena-autor" v-if="single_qa.answear">
              {{ single_qa.odvjetnik.ime }} {{ single_qa.odvjetnik.prezime }}
            </div>
            <!-- <div class=" event-red">Neodgovoreno</div> -->
          </div>
          <div class="case-napomena-txt-autor">
            <div class="case-napomena-txt">{{ single_qa.question }}</div>
            <div class="case-napomena-autor">
              {{ single_qa.fizicka_osoba.ime }}
              {{ single_qa.fizicka_osoba.prezime }}
              <span v-if="single_qa.sender_read"> ({{ $t('components.qna_table.read') }} {{ fullReadDate(single_qa.sender_read) }})</span>
            </div>
            <div
              @click="setEdit(single_qa)"
              class="edit-info add-button"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="13"
                height="13"
                viewBox="0 0 13 13"
              >
                <g>
                  <g>
                    <path
                      fill="#7b7b8a"
                      d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
          </div>

          <!-- <div
            class="add-napomena add-button add-pen remove-item"
            @click="deleteNote(single_qa)"
          >
          <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  ></path>
                </g>
              </g>
            </svg>
          </div> -->
          <!-- <div @click="setEdit(single_qa)" class="edit-info add-button add-pen">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="13"
              height="13"
              viewBox="0 0 13 13"
            >
              <g>
                <g>
                  <path
                    fill="#7b7b8a"
                    d="M2.17 7.695l5.933-5.933 3.134 3.135-5.932 5.933zm10.656-4.386l-1.018 1.018-3.136-3.153L9.69.156 9.706.14a.57.57 0 0 1 .805.016l2.315 2.348c.23.214.23.575 0 .805zm-8.193 7.98l-3.48 1.313a.57.57 0 0 1-.739-.739L1.71 8.382z"
                  ></path>
                </g>
              </g>
            </svg>
          </div> -->
        </div>
      </div>
      <!-- <div class="pagin-wrapp page-nav" v-if="all_pages_notes.length > 1">
              <div
                class="page-nav-prev"
                v-if="!isFirstPageNotes"
                @click="setPageNotes(curr_page_notes - 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1018">
                      <path
                        d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.43895,20.86385v0c-8.37994,0 -15.15353,6.7734 -15.15353,15.15328v0c0,8.37975 6.77359,15.15341 15.15353,15.15341v0c8.3797,0 15.15329,-6.77366 15.15329,-15.15341v0c0,-8.37988 -6.77359,-15.15328 -15.15329,-15.15328z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1018")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          <path
                            class="sssdr"
                            d="M37.11694,40.02775v0l-4.09639,-4.09664v0l4.09639,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M40.30245,40.02775v0l-4.09651,-4.09664v0l4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
              <div class="page-nav-no">
                <div
                  :class="{ 'curr-page': curr_page_notes == 1 }"
                  @click="setPageNotes(1)"
                >
                  1
                </div>
              </div>
              <div class="page-nav-no" v-if="left_dots_visible_notes">
                <div>...</div>
              </div>
              <div
                class="page-nav-no"
                v-for="(str, key) in getLeftRightPagesNotes"
                :key="key"
                @click="setPageNotes(str)"
              >
                <div :class="{ 'curr-page': curr_page_notes == str }">
                  {{ str }}
                </div>
              </div>
              <div class="page-nav-no" v-if="right_dots_visible_notes">
                <div>...</div>
              </div>
              <div class="page-nav-no" v-if="all_pages_notes.length > 1">
                <div
                  :class="{
                    'curr-page': curr_page_notes == all_pages_notes.length,
                  }"
                  @click="setPageNotes(all_pages_notes.length)"
                >
                  {{ all_pages_notes.length }}
                </div>
              </div>
              <div
                class="page-nav-next"
                v-if="!isLastPageNotes"
                @click="setPageNotes(curr_page_notes + 1)"
              >
                <svg
                  id="SVGDoc"
                  width="71"
                  height="72"
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  viewBox="0 0 71 72"
                >
                  <defs>
                    <clipPath id="ClipPath1043">
                      <path
                        d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                        fill="#ffffff"
                      ></path>
                    </clipPath>
                  </defs>
                  <g>
                    <g>
                      <g>
                        <path
                          class="sssdf"
                          d="M35.53479,20.86385v0c8.36551,0 15.1273,6.7616 15.1273,15.12705v0c0,8.36519 -6.76179,15.12718 -15.1273,15.12718v0c-8.36515,0 -15.12682,-6.76199 -15.12682,-15.12718v0c0,-8.36545 6.76167,-15.12705 15.12682,-15.12705z"
                          fill-opacity="0"
                          fill="#ffffff"
                          stroke-dashoffset="0"
                          stroke-dasharray=""
                          stroke-linejoin="miter"
                          stroke-linecap="butt"
                          stroke-opacity="1"
                          stroke="#c2c2c2"
                          stroke-miterlimit="20"
                          stroke-width="2"
                          clip-path='url("#ClipPath1043")'
                        ></path>
                      </g>
                      <g>
                        <g>
                          >
                          <path
                            class="sssdr"
                            d="M33.88303,40.02775v0l4.09651,-4.09664v0l-4.09651,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#2b2b41"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                        <g>
                          <path
                            d="M30.69751,40.02775v0l4.09663,-4.09664v0l-4.09663,-4.09638v0"
                            fill-opacity="0"
                            fill="#ffffff"
                            stroke-dashoffset="0"
                            stroke-dasharray=""
                            stroke-linejoin="miter"
                            stroke-linecap="butt"
                            stroke-opacity="1"
                            stroke="#f6eeff"
                            stroke-miterlimit="20"
                            stroke-width="2"
                          ></path>
                        </g>
                      </g>
                    </g>
                  </g>
                </svg>
              </div>
            </div> -->
    </div>
    <v-dialog v-model="new_notes_open" persistent width="765px">
      <v-card v-if="selected_qa" color="universal-vcard">
        <div class="universal-vdialog-title">Odogovor na upit stranke</div>
        <div class="universal-vdialog-subtext" v-if="selected_qa != null">
          <b
            >{{ selected_qa.fizicka_osoba.ime }}
            {{ selected_qa.fizicka_osoba.prezime }}</b
          >
          <br />
          {{ selected_qa.question }}
        </div>
        <v-textarea
          class="universal-vdialog-textfield"
          label="Odgovor"
          variant="underlined"
          v-model="selected_qa.answear"
        ></v-textarea>

        <!-- <v-text-field
          class="universal-vdialog-textfield"
          
          :label="
            !is_edit_mode
              ? $t('page_2.page_2_1.box_8.popup.placeholder')
              : $t('page_2.page_2_1.box_8.popup.placeholder_edit')
          "
          v-model="note.note_text"
        ></v-text-field> -->
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="resetModal()"
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="updateQA()"
          >
            {{ $t("page_2.page_2_1.box_8.popup.add_btn") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="delete_warning" persistent width="564px">
      <v-card color="universal-vcard">
        <div class="universal-vdialog-title">
          {{ $t("page_2.page_2_1.box_8.delete_popup.title") }}
        </div>
        <div class="vdialog-buttons-wrapper">
          <div
            class="universal-vdialog-button vbutton-secondary"
            @click="
              temp_note = null;
              delete_warning = false;
            "
          >
            {{ $t("repetitive.cancel") }}
          </div>
          <div
            class="universal-vdialog-button vbutton-primary"
            @click="deleteNoteDb()"
          >
            {{ $t("page_2.page_2_1.box_8.delete_popup.delete_btn") }}
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import auth from "@/services/auth";
import moment from "moment";
import share from "@/apiCallers/promise_handler_db/sharepoint";
import Spisi from "@/components/caseComponents/Spisi.vue";
import CaseTab from "@/components/caseComponents/CaseTab.vue";
import MiniCalendar from "@/components/calendarComponents/MiniCalendar.vue";
import person from "@/apiCallers/promise_handler_db/person";
import predmet_hand from "@/apiCallers/promise_handler_db/predmeti";
import permissioner from "@/services/permissioner.js";
import { getCaseData } from "@/router/case/handler";
import DataLoader from "@/components/generalComponents/DataLoader.vue";

export default {
  components: {
    Spisi,
    CaseTab,
    MiniCalendar,
    DataLoader,
  },
  //   props: ["qa_table"],
  data() {
    return {
      notes: [],
      qa_table: [],
      new_notes_open: false,
      all_pages_notes: [],
      finalni_arr_prikaza_notes: [],
      curr_page_notes: 1,
      selected_qa: null,
      br_redova_notes: 3,
      left_dots_visible_notes: false,
      right_dots_visible_notes: false,
      delete_warning: false,
      temp_note: null,
      is_edit_mode: false,
      note: {
        unio: "",
        note_text: "",
      },
      accessToken: null,
    };
  },
  watch: {
    accessToken: function () {
      if (this.accessToken) {
        // this.getGroupById();
      }
    },
    curr_page: function () {
      this.paginirajOdabrane();
    },

    curr_page_notes: function () {
      this.paginirajOdabraneNotes();
    },
  },
  computed: {
    isFirstPageNotes() {
      return this.curr_page_notes == 1;
    },
    isLastPageNotes() {
      return (
        this.curr_page_notes ==
        this.all_pages_notes[this.all_pages_notes.length - 1]
      );
    },
    getLeftRightPagesNotes() {
      // Init values
      let return_pages = [];
      this.right_dots_visible_notes = false;
      this.left_dots_visible_notes = false;
      // Left of current page
      // 3 is the bottom value to make ... sense
      // LEFT LOOP
      let left_start = 2;
      let left_end = this.curr_page_notes;
      if (this.curr_page_notes == this.all_pages_notes.length)
        left_end = this.curr_page_notes - 1;
      if (this.curr_page_notes > 3) {
        left_start = this.curr_page_notes - 1;
        this.left_dots_visible_notes = true;
      }
      for (let j = left_start; j <= left_end; j++) {
        return_pages.push(j);
      }
      // RIGHT LOOP
      let right_start = this.curr_page_notes + 1;
      if (right_start < this.all_pages_notes.length)
        return_pages.push(right_start);
      if (right_start < this.all_pages_notes.length - 1)
        this.right_dots_visible_notes = true;
      return return_pages;
    },
  },
  methods: {
    resetModal() {
      this.selected_qa = null;
      this.new_notes_open = false;
    },
    async updateQA() {
      if (
        (this.selected_qa.answear != "" &&
        this.selected_qa.answear != null &&
        this.selected_qa.answear ) || (this.selected_qa.answear == "" && !this.selected_qa.first_time)
      ) {
        if(this.selected_qa.answear == "" && !this.selected_qa.first_time){
          this.selected_qa.responder_id = null;
        }else{
          this.selected_qa.responder_id = this.$store.state.logged_in_user.uid;
        }
        await predmet_hand
          .updateSingleQa(this.selected_qa)
          .then(async (resp) => {
            this.qa_table = resp.data;
            this.resetModal();
          });
      } else {
        this.new_notes_open = false;
      }
    },

    async getNewData() {
      this.accessToken = this.$store.state.aToken;
      await predmet_hand
        .getSingleCaseQA(this.$route.params.uid)
        .then((resp) => {
          this.qa_table = resp.data;
          console.log(this.qa_table, "qa_table");
        });
    },

    is_permission_inside(wanted_permission, check_assistent = true) {
      return permissioner.check_case_permsision(
        wanted_permission,
        check_assistent
      );
    },

    paginirajOdabrane() {
      let start_idx = 0 + this.br_redova_notes * (this.curr_page - 1);
      let end_idx = this.br_redova_notes * this.curr_page;

      this.finalni_arr_prikaza = this.napomene.slice(start_idx, end_idx);
    },

    setPageNotes(pg) {
      this.curr_page_notes = pg;
    },
    calculatePageNumberNotes() {
      this.all_pages_notes = [];
      var finalni_broj = this.notes.length / this.br_redova;
      if (this.notes.length % this.br_redova_notes >= 1) {
        finalni_broj++;
      }
      for (var i = 1; i <= finalni_broj; i++) {
        this.all_pages_notes.push(i);
      }
      if (this.all_pages_notes.length != 0) {
        this.curr_page_notes = 1;
      }
    },
    paginirajOdabraneNotes() {
      let start_idx = 0 + this.br_redova_notes * (this.curr_page_notes - 1);
      let end_idx = this.br_redova_notes * this.curr_page_notes;

      this.finalni_arr_prikaza_notes = this.notes.slice(start_idx, end_idx);
      console.log(this.finalni_arr_prikaza_notes, "finalni_arr_prikaza_notes");
    },
    setPageActivity(pg) {
      this.curr_page_act = pg;
    },
    switchDate(inData) {
      return moment(inData.toString()).format("LL");
    },
    fullReadDate() {
      return moment().format("LLL ");
    },
    getTime(inData) {
      return moment(inData.toString()).format("HH:mm");
    },
    getMonth() {
      return this.mjeseci[moment().month()];
    },
    getYear() {
      return moment().year();
    },

    getOdvjetnik(na) {
      const od = this.odvjetnici.find((o) => o.odvjetnik.uid == na);
      console.log(od);
      return od != null ? od.odvjetnik.ime + " " + od.odvjetnik.prezime : "";
    },
    resetNoteDetails() {
      this.note = {
        details: "",
        unio: "",
      };
      this.temp_note = null;
      this.is_edit_mode = false;
      this.new_notes_open = false;
    },
    setEdit(na) {
      this.selected_qa = { ...na };
      this.is_edit_mode = true;
      this.new_notes_open = true;
      this.selected_qa["first_time"] = this.selected_qa.answear == null;
    },
    deleteNote(na) {
      this.temp_note = na;
      this.delete_warning = true;
    },
    async deleteNoteDb() {
      console.log(this.temp_note);
      await predmet_hand
        .deleteNote(this.temp_note.uid)
        .then(() => {})
        .finally(() => {
          this.temp_note = null;
          this.delete_warning = false;
          this.refreshNotes();
        });
    },
    async addNote() {
      if (this.note.note_text.trim() != "") {
        this.note.unio = this.$store.state.logged_in_user.uid;
        await predmet_hand
          .addPredmetNote(this.note, this.$route.params.uid)
          .then(async () => {
            await this.refreshNotes();
          })
          .finally(() => {
            this.resetNoteDetails();
          });
      } else {
        this.new_notes_open = false;
      }
    },
    async editNote() {
      if (this.note.note_text.trim() != "") {
        this.note.unio = this.$store.state.logged_in_user.uid;
        await predmet_hand
          .editPredmetNote(this.note, this.temp_note.uid)
          .then(async () => {
            await this.refreshNotes();
          })
          .finally(() => {
            this.resetNoteDetails();
          });
      } else {
        this.new_notes_open = false;
      }
    },
    async refreshNotes() {
      await predmet_hand
        .getPredmetNotes(this.$route.params.uid)
        .then((resp) => {
          this.notes = resp.data;
          console.log(this.notes, "notes");
          this.calculatePageNumberNotes();
          this.paginirajOdabraneNotes();
        });
    },
    get_avatar(user_id) {
      return {
        backgroundImage: "url("+process.env.VUE_APP_API_ENDPOINT_STARTER+"/" + user_id + ".jpeg)",
      };
    },
  },
  async created() {
    this.accessToken = this.$store.state.aToken;
    this.getNewData();
  },
  mounted() {
    setTimeout(this.openWordClient, 3500);
  },
};
</script>

<style></style>
